import { Node, mergeAttributes } from '@tiptap/core';

// UI-SPEC missing-value tooltip copy (Copywriting Contract).
const UNAVAILABLE_TITLE =
  'This value is missing from the claim record. Add it to the claim, then regenerate the preview.';

/**
 * Read-only atomic inline node serializing to `<span data-variable="…">`.
 *
 * Storage contract (06-RESEARCH Pattern 3):
 * - `editor.getHTML()` keeps the stable `data-variable` attribute (canonical);
 *   the visible text is display-only and re-resolved server-side at render.
 * - `editor.getJSON()` stores only `{type: 'variableChip', attrs: {variable}}`
 *   — no PHI value ever lands in content_json.
 */
export const VariableChip = Node.create({
  name: 'variableChip',
  group: 'inline',
  inline: true,
  atom: true, // single, non-editable unit; cursor skips over it
  selectable: true,

  addOptions() {
    return { resolveVariable: null }; // caller passes context_snapshot lookup
  },

  addAttributes() {
    return {
      variable: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-variable'),
        renderHTML: (attrs) => ({ 'data-variable': attrs.variable }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-variable]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const key = node.attrs.variable;
    // Editor DOM shows the resolved value; storage HTML keeps the stable placeholder attr.
    const raw = this.options.resolveVariable ? this.options.resolveVariable(key) : `{${key}}`;
    const unavailable = raw == null || raw === '';
    const display = unavailable ? '[unavailable]' : raw;
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        class: unavailable ? 'variable-chip variable-chip--unavailable' : 'variable-chip',
        contenteditable: 'false',
        title: unavailable ? UNAVAILABLE_TITLE : key,
      }),
      display,
    ];
  },
});
